import React from 'react';
import { ProgressBar } from 'react-bootstrap';

export const IstProgress = (props) => {
    if (props.value.toString().length > 0) {
        return (
            <ProgressBar now={props.value} label={`${props.value}%`} />
        );
    }
    return ("Loading..");
};

